module.exports = __webpack_public_path__ + "static/media/4.Brush cutter.38502e49.jpg";